<template>
  <div class="line-item-summary">
    <v-grid>
      <v-row>
        <v-col>
          <table>
            <tr v-if="summary.itemTotal" class="line-item-summary__item">
              <th>{{ $t('order_sub_total') }}:</th>
              <td>
                {{ formatPrice(summary.itemTotal) }}
              </td>
            </tr>
            <percentage-promotion-item
              v-for="(item, index) in summary.promotionItems"
              :key="index"
              :item="item"
            />
            <tr
              v-if="loadingShipping"
              class="line-item-summary__item line-item-summary__item--loading"
            >
              <th>{{ $t('shipping') }}:</th>
              <td><three-dots-loading /></td>
            </tr>
            <tr
              v-else-if="
                !loadingShipping &&
                summary.shipmentTotal &&
                (($isBrStore && summary.shipmentTotal > 0) || $isGlobalStore)
              "
              class="line-item-summary__item"
            >
              <th>{{ $t('shipping') }}:</th>
              <td :class="[{ 'line-item-summary__item-free': freeShipping }]">
                {{
                  $isGlobalStore
                    ? freeShipping
                      ? $t('free')
                      : summary.shipmentTotal
                    : formatPrice(summary.shipmentTotal)
                }}
              </td>
            </tr>
            <adjustment-item
              v-for="(adjustment, index) in summary.adjustmentTotal"
              :key="index"
              :adjustment="adjustment"
              @updateCart="updateCart"
            />
            <adjustment-item
              v-if="summary.promotionDiscount"
              :adjustment="summary.promotionDiscount"
              @updateCart="updateCart"
            />
            <tr
              v-if="summary.installments && summary.installmentsTotal"
              class="line-item-summary__item"
            >
              <th>{{ $t('installments') }}:</th>
              <td>
                {{ summary.installments }}x
                {{ formatPrice(summary.installmentsTotal) }}
              </td>
            </tr>
            <tr
              v-if="summary.total"
              class="line-item-summary__item line-item-summary__item--total"
            >
              <th>{{ $t('order_total') }}:</th>
              <td>
                {{
                  $isGlobalStore ? summary.total : formatPrice(summary.total)
                }}
              </td>
            </tr>
            <tr v-if="date" class="line-item-summary__item">
              <th>{{ $t('order_date') }}:</th>
              <td>
                {{ date }}
              </td>
            </tr>
          </table>
        </v-col>
      </v-row>
    </v-grid>
  </div>
</template>

<script>
import priceable from '~/mixins/priceable'
import convertDate from '~/utils/convertDate'
import VGrid from '~/components/v-grid/VGrid.vue'
import VRow from '~/components/v-grid/v-row/VRow.vue'
import VCol from '~/components/v-grid/v-row/v-col/VCol.vue'
import ThreeDotsLoading from '~/components/loadings/three-dots/ThreeDotsLoading.vue'
import AdjustmentItem from '~/components/cart/adjustment-item/AdjustmentItem'
import PercentagePromotionItem from '~/components/cart/percentage-promotion-item/PercentagePromotionItem.vue'

export default {
  components: {
    VGrid,
    VRow,
    VCol,
    ThreeDotsLoading,
    AdjustmentItem,
    PercentagePromotionItem,
  },
  mixins: [priceable],
  props: {
    summary: {
      type: Object,
      required: true,
    },
    loadingShipping: {
      type: Boolean,
      default: false,
    },
    freeShipping: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    date() {
      if (!this.summary || !this.summary.orderDate) return null
      return convertDate(this.summary.orderDate, this.$store.state.locale)
    },
  },
  methods: {
    updateCart(cart) {
      this.$emit('updateCart', cart)
    },
  },
}
</script>

<style lang="scss" scoped>
.line-item-summary {
  display: flex;
  justify-content: flex-end;
  line-height: normal;
  padding: 0 4 * $v4_gutter;
  margin: 5px 0;
  width: 100%;

  .line-item-summary__item-free {
    color: $v4_color_primary;
  }

  .line-item-summary__item--total {
    td {
      font-weight: 700;
    }
  }

  .line-item-summary__item--loading {
    td {
      padding-left: 20px;
      height: 18px;
    }
  }

  .line-item-summary__item {
    th,
    td {
      font-size: 15px;
      text-align: right;
      padding-bottom: 5px;
    }

    th {
      color: #a2a2a6;
      padding: 0 5px 0 0;
      font-weight: 400;
    }
  }
}
</style>
